import { render, staticRenderFns } from "./HrRenovaLayout.vue?vue&type=template&id=0cf209ae&"
import script from "./HrRenovaLayout.vue?vue&type=script&lang=js&"
export * from "./HrRenovaLayout.vue?vue&type=script&lang=js&"
import style0 from "./HrRenovaLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports